export default "__VITE_ASSET__524350b4__"